
export abstract class CryptoRepository {
    abstract encrypt(data: string, password: string): string;
    abstract decrypt(encryptedData: string, password: string): string;
}
